<div class="sidebar-page-content copo-no-user-select sidenav-content" cdkScrollable>
	<div class="guarantee-card-title-block-non-sticky">
		<copo-back-button></copo-back-button>
		<div class="guarantee-card-title-content">
			<span class="guarantee-card-title-label" translate>guarantee.card.title</span>
			<span class="guarantee-card-title-label">&nbsp;{{ guarantee.guaranteeId ? (guarantee.guaranteeId | uppercase) : UNDERSCORE }}</span>
			<span class="guarantee-card-title-label"> - &nbsp;{{ guarantee.name ? (guarantee.name | uppercase) : UNDERSCORE }}</span>
		</div>
		<button type="button" mat-raised-button class="request-certificate-button"
			*ngIf="isSatisfied(guarantee)" [disabled]="requestingCertificate" (click)="requestCertificate()">
			<span translate>guarantee.certificate.request</span>
		</button>
		<div class="guarantee-card-title-actions" *ngIf="isDraft(guarantee)">
			<button type="button" mat-flat-button color="primary" (click)="editDraft(guarantee.id!)">
				<span translate>edit.draft</span>
				<mat-icon iconPositionEnd svgIcon="copo_pencil"></mat-icon>
			</button>
			<button type="button" mat-flat-button (click)="evtDeleteDraft(guarantee)">
				<span translate>quapp.action.delete</span>
			</button>
		</div>
	</div>
	<copo-feedback-error class="guarantee-card-error"></copo-feedback-error>
	<div class="guarantee-informations-block">
		<div class="guarantee-informations-block-item">
			<div class="guarantee-informations-block-identity">
				<div class="guarantee-informations-block-title" translate>guarantee.card.info</div>
				<div class="pill guarantee-informations-block-status" 
					[class.request-status-bg-draft]="isDraft(guarantee)"
					[class.request-status-bg-open]="isOpen(guarantee)" 
					[class.request-status-bg-other]="isOther(guarantee)"
					[class.request-status-bg-satisfied]="isSatisfied(guarantee)" 
					[class.request-status-bg-certificate-requested]="isCertificateRequested(guarantee)"
					[class.request-status-bg-certificate-issued]="isCertificateIssued(guarantee)"
					[class.request-status-bg-rejected]="isRejected(guarantee)"
					[class.request-status-bg-cancelled]="isCancelled(guarantee)" 
					[class.request-status-bg-unknown]="isUnknown(guarantee)">
					<span class="guarantee-informations-block-status-label">{{ getGuaranteeRequestStatus(guarantee.status) }}</span>
				</div>
			</div>
			<div class="guarantee-informations-block-info">
				<div class="guarantee-informations-block-info-item">
					<div class="guarantee-informations-block-label" translate>guarantee.request.date</div>
					<div class="guarantee-informations-block-value">{{ guarantee.requestDate ? (guarantee.requestDate | copoDate:'date') : '' }}</div>
				</div>
				<div class="guarantee-informations-block-info-item">
					<div class="guarantee-informations-block-label" translate>guarantee.request.id</div>
					<div class="guarantee-informations-block-value">{{ guarantee.guaranteeId ? guarantee.guaranteeId : UNDERSCORE }}</div>
				</div>
				<div class="guarantee-informations-block-info-item">
					<div class="guarantee-informations-block-label" translate>guarantee.request.certificate.id</div>
					<ng-container *ngIf="guarantee.certificateDocument as certificate; else noCertificateDocument">
						<a class="guarantee-informations-block-value guarantee-certificate-link" target="_blank"
							rel="noopener" [title]="certificate.name"
							[href]="getAttachmentUrl(guarantee.id!, certificate) | copoSafeUrl"
							(click)="showAttachment($event, certificate)">
							{{ certificate.name }}
						</a>
					</ng-container>
					<ng-template #noCertificateDocument>
						<div class="guarantee-informations-block-value">{{ UNDERSCORE }}</div>
					</ng-template>
				</div>
				<div class="guarantee-informations-block-info-item">
					<div class="guarantee-informations-block-label" translate>guarantee.card.client.project.name</div>
					<div class="guarantee-informations-block-value">{{ guarantee.name | uppercase }}</div>
				</div>
				<div class="guarantee-informations-block-info-item">
					<div class="guarantee-informations-block-label" translate>guarantee.last.modified.date</div>
					<div class="guarantee-informations-block-value">{{ guarantee.lastModifiedDate ? (guarantee.lastModifiedDate | copoDate:'date') : '' }}</div>
				</div>
			</div>
		</div>
	</div>
	<div class="guarantee-informations-block"
		*ngIf="guarantee.certificates.length > 0 || guarantee.crmAttachments.length > 0">
		<div class="guarantee-informations-block-item">
			<div class="guarantee-informations-block-identity">
				<div class="guarantee-informations-block-title" translate>search.certificates</div>
			</div>
			<ng-container *ngIf="guarantee.certificates.length > 0; else nocertificate">
					<div class="guarantee-details-block-value" *ngFor="let certificate of getCertificates(guarantee)">
					<a target="_blank" rel="noopener" [href]="getAttachmentUrl(guarantee.id!, certificate) | copoSafeUrl"
							(click)="showAttachment($event, certificate)" class="attachment-container" [title]="certificate.name">
						<mat-icon svgIcon="table_document" class="setting-icon-16 left-pad"></mat-icon>
						{{ certificate.name }}
					</a>
				</div>
			</ng-container>
			<ng-template #nocertificate><span>{{ UNDERSCORE }}</span></ng-template>
		</div>
	</div>
	<div class="guarantee-informations-block" *ngIf="guarantee.crmAttachments.length > 0">
		<div class="guarantee-informations-block-item">
			<div class="guarantee-informations-block-identity">
				<div class="guarantee-informations-block-title" translate>guarantee.proposals</div>
			</div>
			<ng-container *ngIf="guarantee.crmAttachments.length > 0; else noattachment">
				<div class="guarantee-details-block-value"
					*ngFor="let attachment of getProposalsAndOtherDocuments(guarantee)">
					<a target="_blank" rel="noopener" [href]="getAttachmentUrl(guarantee.id!, attachment) | copoSafeUrl"
						(click)="showAttachment($event, attachment)" class="attachment-container">
						<mat-icon svgIcon="table_document" class="setting-icon-16 left-pad"></mat-icon>
						{{ attachment.name }}
					</a>
				</div>
			</ng-container>
			<ng-template #noattachment><span>{{ UNDERSCORE }}</span></ng-template>
		</div>
	</div>
	<div class="copo-form-container guarantee-details-title" translate>guarantee.card.details</div>
	<copo-guarantee-request-summary [guarantee]="guarantee" [showAdditionalDocuments]="true"></copo-guarantee-request-summary>
</div>